import { signal } from '@preact/signals-core'
import { COLOR_SCHEME_LIGHT } from '../const'
import { searchboxConfig as defaultConfig } from '../defaultConfig'
import type { ColorScheme } from '../types'

export const colorScheme = signal<ColorScheme>(COLOR_SCHEME_LIGHT)
export const themeConfig = signal<typeof defaultConfig.ui.theme>(defaultConfig.ui.theme)
export const title = signal<string>('Search results for: ')
export const queryTerm = signal<string | null>(null)
